import React from 'react';
import Link from '@v2/shared/components/Link';
import { useSite } from '@v2/shared/lib/site';
import useUrlGenerator from '@v2/shared/lib/useUrlGenerator';

type Props = {
  /** The brand's mark, imported from its own `Navigation/images` so Vite fingerprints it. */
  src: string;
  width: number;
  height: number;
  /**
   * How the brand draws it. The sizes are the header's own and one of them is responsive,
   * so they cannot be derived from `width`/`height` — Tailwind cannot generate a class
   * from a number it only sees at runtime.
   */
  className?: string;
};

/**
 * The site's mark, linking home.
 *
 * headless: apps/topmags/layouts/MainLayout/Navigation/Logo. The asset is bundled rather
 * than read out of `/resources/<site>/`: the resources directory is a sites-config option
 * that never reaches the browser, and Vite rewrites the import to the built asset's real
 * url on every environment.
 *
 * `alt` is the site's display name rather than a prop, because that is a fact the site
 * already carries and no brand has ever wanted to disagree with it.
 */
export default function Logo({ src, width, height, className }: Props) {
  const site = useSite();
  const { buildUrl } = useUrlGenerator();

  return (
    <Link href={buildUrl('/')} className="shrink-0 md:pr-5">
      <img src={src} alt={site.name} width={width} height={height} className={className} />
    </Link>
  );
}
